import FormatDate from "../../../common/FormatDate";
const nhanVien= {
    "_id":null,
    "hoTen": null,
    "anhDaiDien": null,
    "gioiTinh": null,
    "diaChi": null,
    "soCMND": null,
    "soDienThoai": null,
    "email":null,
    "matKhau": null,
    "donVi":null,
    "matKhau":null

}

function getNhanVienThem(){
  return   {
        "hoTen": null,
        "anhDaiDien": "https://img.icons8.com/external-kiranshastry-solid-kiranshastry/344/external-user-management-kiranshastry-solid-kiranshastry-6.png",
        "gioiTinh": null,
        "diaChi": null,
        "soCMND": null,
        "soDienThoai": null,
        "matKhau": "Vnpt@147",
        "email":null,
        "donVi":null,
        "listNQ":[{"tenQuyen":"ROLE_NHANVIEN"}]
    };
};
function getNhanVien(){
    return nhanVien;
}
function kiemTaNhanVien(nhanVien){
    if(nhanVien.hoTen==null||nhanVien.hoTen==""){
        return "Tên nhân viên không được để trống"
        
    }else if(!nhanVien.soDienThoai?.match(/^\(?([0]{1})\)?([0-9]{9})$/)){
        return "Số điện thoại không hợp lệ" 
        
    }else if(!nhanVien.email?.match(/^\w+([\.-]?\w+)*@vnpt.vn$/)){
        return "Email không hợp lệ phải là email ...@vnpt.vn"
    }
    else if(nhanVien.soCMND!=null){
        if(!nhanVien.soCMND?.match(/^\d{9}$/)&&!nhanVien.soCMND?.match(/^\d{12}$/)){
            return "Số CMND không hợp lệ"
            
        } 
    }else if(nhanVien.donVi==null){
        return "Cần chọn đơn vị"
        
    }
    // if(nhanVien._id!=""){
    if(nhanVien.matKhau=="" || nhanVien.matKhau == undefined || nhanVien.matKhau?.length<6){
        return "Mật khẩu ít nhất 6 kí tự"
        
    }
    
    if(nhanVien.listNQ?.length==0){
        return "Cần chọn chức vụ"     
    }
    if(nhanVien.ngaySinh!=null){
        if(FormatDate.soSachNgay(nhanVien.ngaySinh,"2008-01-01")>0){
            return "Ngày sinh quá nhỏ" 
        }
    }
    
    // }
    return "";

}
const nhanVienUtil={
    getNhanVienThem,
    getNhanVien,
    kiemTaNhanVien
   
};
export default nhanVienUtil;